define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../models/UserContext", "../../shared/dataLogs", "./cpPackagesActions", "../../models/CPPackageModel"], function (require, exports, $, ko, log, urls_1, tools, UserContext, DataLogs, CPPackagesActions, CPPackageModel) {
    "use strict";
    var CPPackageDetails = /** @class */ (function () {
        function CPPackageDetails() {
            this.userCanViewUser = ko.observable(UserContext.hasAccess("Admin,CPPackages.View,CPPackages.Edit,CPPackages.Delete"));
            this.userCanAddUser = ko.observable(UserContext.hasAccess("Admin,CPPackages.Edit,CPPackages.Delete"));
            this.filterByAny = ko.observable("");
            this.editModel = ko.observable(new CPPackageModel());
        }
        CPPackageDetails.prototype.init = function (id) {
            var self = this;
            $("#page-title").text("CP Package Details");
            var getModelCall = self.getCPPackageById(id);
            $.when(getModelCall).done(function () {
                self.cpActions = new CPPackagesActions();
                self.cpActions.afterSuccess = function () {
                    self.getCPPackageById(id);
                };
                ko.applyBindings(self, document.getElementById("main-container"));
                $("#contextLoader").hide();
                $("#mainContext").show();
            });
        };
        CPPackageDetails.prototype.getCPPackageById = function (id) {
            var self = this;
            return tools.ajaxGet({
                url: "/CPPackages/GetCPPackageById",
                data: { id: id },
                success: function (result) {
                    if (result.Success) {
                        self.editModel(new CPPackageModel(result.Data));
                    }
                }
            });
        };
        CPPackageDetails.prototype.addCPPackage = function () {
            var self = this;
            self.cpActions.editPackage();
        };
        CPPackageDetails.prototype.editCPPackage = function () {
            var self = this;
            self.cpActions.editPackage(self.editModel().Id());
        };
        CPPackageDetails.prototype.showLogs = function () {
            var self = this;
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("CPPackage", self.editModel().Id());
                dataLogs.open("CP Package logs");
            }
        };
        return CPPackageDetails;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/CPPackages/Details")) {
            var id = urls_1.urls.getIdFromQueryString();
            if (id <= 0) {
                id = urls_1.urls.getIdFromUrl();
            }
            log.log("Initialize CPPackage details");
            $(function () {
                (new CPPackageDetails()).init(id + '');
            });
        }
    }, 0);
    return CPPackageDetails;
});
//# sourceMappingURL=cpPackagesDetails.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customerPortalAdmin/cpPackagesDetails.js
// module id = 312
// module chunks = 2